import React from 'react';
import {
    IpsativeQuestionSlideWrapper,
    QuestionContent,
    QuestionText,
    ButtonsWrapper,
    QuestionGroup,
} from 'pages/questionnaire/slides/ipsative/IpsativeQuestionSlide.styled';
import { Questionnaire } from 'types/app';
import { PageTitle } from 'layout/page/Page.layout.styled';
import { getLocaleValue } from 'helpers/utils';
import { useTranslation } from 'react-i18next';
import IpsativeResponses from 'components/questionnaire/IpsativeResponses';
import Button from 'components/common/button/Button';

export interface IpsativeQuestionSlideProps {
    question?: Questionnaire.IIpsativeQuestion;
    gotoPrevious?: () => void;
    gotoNext?: () => void;
    onAnswer?: (questionWithResponse: Questionnaire.IIpsativeQuestion) => void;
}

const IpsativeQuestionSlide: React.FC<IpsativeQuestionSlideProps> = ({
    question,
    gotoPrevious,
    gotoNext,
    onAnswer,
}) => {
    const { i18n, t } = useTranslation('translation');

    const handleAnswerSelect = (answer: Questionnaire.IIpsativeAnswer) => {
        if (question && onAnswer) {
            const updatedQuestion: Questionnaire.IIpsativeQuestion = {
                ...question,
                selectedAnswerId: answer.id,
            };
            onAnswer(updatedQuestion);
        }
    };

    if (!question) {
        return null;
    }

    return (
        <IpsativeQuestionSlideWrapper>
            <PageTitle style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                // display: 'none'
            }}>{t('questionnaire.ipsative.title')}</PageTitle>
            <QuestionContent>
                {question.group && (
                    <QuestionGroup>{getLocaleValue(question.group.label, i18n.language)}</QuestionGroup>
                )}
                <QuestionText>{getLocaleValue(question.label, i18n.language)}</QuestionText>
                <IpsativeResponses
                    answers={question.answers}
                    selectedAnswerId={question.selectedAnswerId}
                    onSelect={handleAnswerSelect}
                />
                <ButtonsWrapper>
                    <Button
                        onClick={() => {
                            gotoPrevious && gotoPrevious();
                        }}
                        fill="outline"
                        className={!gotoPrevious ? 'btn-navigate-disabled' : 'btn-navigate'}
                        disabled={!gotoPrevious}
                    >
                        {t('common.previous')}
                    </Button>
                    <Button
                        onClick={() => {
                            gotoNext && gotoNext();
                        }}
                        fill="outline"
                        className={!gotoNext ? 'btn-navigate-disabled' : 'btn-navigate'}
                        disabled={!gotoNext}
                    >
                        {t('common.next')}
                    </Button>
                </ButtonsWrapper>
            </QuestionContent>
        </IpsativeQuestionSlideWrapper>
    );
};

export default IpsativeQuestionSlide;
